import {Directive} from '@angular/core';
import AppControlGuids from '../../../../../../src/app/api/ControlGuids';
import LibControlGuids from '../../../../../frontier/nucleus/src/lib/apiv2/ControlGuids';

export interface IGuidSuggestion {
  key: string;
  value: string;
}

const GUID_PATTERN: RegExp = /^[0-9a-fA-F]{32}$/;

@Directive()
export abstract class GuidSearchBase {
  guidSuggestions: IGuidSuggestion[] = [];

  protected abstract applyGuidValue(value: string): void;

  protected onGuidInputChanged(value: string): void {
    if (GUID_PATTERN.test(value ?? '')) {
      this.guidSuggestions = [];
      this.applyGuidValue(value);
      return;
    }
    this.guidSuggestions = this.searchGuids(value);
  }

  searchGuids(query: string): IGuidSuggestion[] {
    if (!query || query.length < 2) return [];
    const q: string = query.toLowerCase();
    const all = {...AppControlGuids, ...LibControlGuids};
    return Object.entries(all)
      .filter(([k, v]: [string, string]): boolean => k.toLowerCase().includes(q) || v.toLowerCase().includes(q))
      .map(([key, value]: [string, string]): IGuidSuggestion => ({key, value}));
  }

}
